import { generatePath, useNavigate } from 'react-router-dom';

import { WidgetCard } from 'us-react-components/dist/WidgetCard/WidgetCard';
import { Referral, ReferralOffer } from 'us-web-services';
import { useDependencies } from '../dependencies';
import { Routes } from '../Routes';
import { TrackerTypes } from '../services';
import { Button, ButtonType } from './Button';

const URBANSITTER_ICON_URL = 'https://assets.urbansitter.com/static/img/logos/urbansitter-icon.svg';

type Props = {
  referral: Referral;
  referralOffer: ReferralOffer;
}

export const ReferralOfferReceived = (props: Props): JSX.Element => {
  const { referral, referralOffer } = props;

  const {
    services: { tracker },
  } = useDependencies();

  const navigate = useNavigate();

  // Returns the last 3 words of the ReferralOffer content string ("see Name's favorites") without the period at end
  const getCtaString = (offer: ReferralOffer): string | undefined => offer?.content?.split(' ').slice(-3).join(' ').slice(0, -1);

  const handleCtaClick = async (): Promise<void> => {
    const path = generatePath(Routes.parent.bookedSitters, { id: referral.referringUserId });

    await tracker.track('clicked-button', { elementId: 'referral-parent-view-sitters' }, 'referral-parent', { services: [TrackerTypes.GA] });

    navigate(path);
  }

  return (
    <WidgetCard
      pictureUrl={referralOffer.image ?? URBANSITTER_ICON_URL}
      title={referralOffer.title ?? ''}
      description={referralOffer.content ?? ''}
      hasButton
      buttonComponent={<Button
        buttonType={ButtonType.primary}
        style={{ textTransform: 'capitalize' }}
        onClick={handleCtaClick}
      >{getCtaString(referralOffer) ?? ''}
      </Button>
      }
    />
  );
};
